import React from "react";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import {apollo_useStyles} from "./Apollo_styles";
import {ApolloContext} from "./Apollo_Context";
import {
  home_path,
  accountdetailapollo_path,
  accountdetailzeus_path,
  accountgroupdetail_path,
  accountgroups_path,
  campaigndetailzeus_path,
  campaigns_path,
  operations_path,
  reports_path,
  adgroupdetail_path, info_path, infodetail_path, operation_platform_path, heraaudiences_path, herasetpoints_path,
  advertisementdetail_path
} from "./Apollo_links";

interface Breadcrumbs {
  bread_no: number;
  zeusaccountid: number | null;
  zeuscampaignid: number | null;
  adgroupid: number | null;
  adid: number | null;
  query: string | null;
  platform: string | null;
}

type BreadcrumbsData = [{
  id: number,
  path: string,
  displayword: string,
}];
export const ApolloBreadcrumbs: React.FC<Breadcrumbs> = ({bread_no, zeusaccountid, zeuscampaignid, adgroupid, adid, query, platform}) => {
  const classes = apollo_useStyles();
  const {state} = React.useContext(ApolloContext)

  const global_breadcrumbNameMap = [
    {
      id: 0, data: [
        {id: 1, path: '#', displayword: 'ホーム'},
      ] //ホーム（全体サマリー）
    },
    {
      id: 1, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'アカウントグループ一覧'},
      ] //アカウントグループ一覧画面
    },
    {
      id: 2, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'クリエイティブアセットTOP'}
      ] //CRTOP
    },
    {
      id: 3, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: '配信設定TOP'}
      ] //OPeTop
    },
    {
      id: 4, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/crassets', displayword: 'クリエイティブアセットTOP'},
        {id: 3, path: '#', displayword: 'クリエイティブアセット一覧（Zeus）'},
      ] //クリエイティブ一覧（ＺＥＵＳ）
    },
    {
      id: 5, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/crassets', displayword: 'クリエイティブアセットTOP'},
        {id: 3, path: '/crassets/' + platform + '/' + state.current.accountGroupId + '/' + state.current.accountId +'/' + zeusaccountid, displayword: 'クリエイティブアセット一覧（Zeus）'},
        {id: 4, path: '#', displayword: '広告アセット（画像）作成（Zeus）'}
      ] //クリエイティブ画像編集
    },
    {
      id: 6, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/crassets', displayword: 'クリエイティブアセットTOP'},
        {id: 3, path: '/crassets/' + platform + '/' + state.current.accountGroupId + '/' + state.current.accountId + '/' + zeusaccountid, displayword: 'クリエイティブアセット一覧（Zeus）'},
        {id: 4, path: '#', displayword: 'クリエイティブアセット詳細（画像）'}
      ] //クリエイティブ画像詳細
    },
    {
      id: 7, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: campaigndetailzeus_path + state.current.accountGroupId + '/' + state.current.accountId + '/' + zeusaccountid + '/' + zeuscampaignid + `?type=${query}`,
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {id: 4, path: '#', displayword: '広告グループ作成'}
      ] //広告グループ編集
    },
    {
      id: 8, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: operations_path, displayword: '配信設定TOP'},
        {
          id: 3,
          path: campaigndetailzeus_path + state.current.accountGroupId + '/' + state.current.accountId + '/' + zeusaccountid + '/' + zeuscampaignid + `?type=${query}`,
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 4,
          path: adgroupdetail_path + state.current.accountGroupId + '/' + state.current.accountId + '/' + zeusaccountid + '/' + zeuscampaignid + '/' + adgroupid + `?type=${query}`,
          displayword: '広告グループ詳細'
        },
        {id: 6, path: '#', displayword: '広告グループ編集'},
      ] //広告グループ編集
    },
    {
      id: 9, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {id: 4, path: '#', displayword: '広告主アカウント詳細'}
      ] //アカウント詳細
    },
    {
      id: 10, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: '#', displayword: 'アカウントグループ作成'},
      ] //アカウントグループ新規作成
    },
    {
      id: 11, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {id: 4, path: '#', displayword: 'アカウントグループ編集'}
      ] //アカウントグループ編集
    },
    {
      id: 12, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: '#', displayword: 'アカウントグループ詳細'},
      ]   //アカウントグループ詳細
    },
    {
      id: 13, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {id: 5, path: '#', displayword: 'Zeusアカウント詳細'},
      ] //アカウント（ZEUS)詳細
    },
    {
      id: 14, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {id: 4, path: '#', displayword: '広告主アカウント作成'},
      ] //アカウント（Apollo)新規作成
    },
    {
      id: 15, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {id: 5, path: '#', displayword: '広告主アカウント編集'},
      ] //アカウント（Apollo)編集
    },
    {
      id: 16, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {id: 5, path: '#', displayword: 'Zeusアカウント作成'}
      ]// zeusアカウント作成
    },
    {
      id: 17, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {
          id: 5,
          path: accountdetailzeus_path + state.current.accountGroupId + '/' + state.current.accountId + "/" + state.current.accountId + "/" + zeusaccountid,
          displayword: 'Zeusアカウント詳細'
        },
        {id: 6, path: '#', displayword: 'Zeusアカウント編集'},
      ]//zeusアカウント編集
    },
    {
      id: 18, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/campaigns', displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/` + zeuscampaignid + '?type=cp',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {id: 4, path: '?type=cp', displayword: '広告グループ詳細'},

      ]//広告グループ詳細
    },
    {
      id: 19, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '/operation/zeus', displayword: 'Zeusキャンペーン一覧'},
        {
          id: 4,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/` + zeuscampaignid + '?type=op',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {id: 5, path: '?type=op', displayword: '広告グループ詳細'},

      ]//広告グループ詳細
    },
    {
      id: 20, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '#', displayword: 'Zeusキャンペーン一覧'},
      ]//OperationTop
    },
    {
      id: 21, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '/operation/zeus/', displayword: 'Zeusキャンペーン一覧'},
        {id: 4, path: '#', displayword: '一括処理アップロード'},
      ]//OperationCSVUpload
    },
    {
      id: 22, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/campaigns', displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=cp',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 4,
          path: '/adgroupdetail/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=cp',
          displayword: '広告グループ詳細'
        },
        {id: 5, path: '?type=cp', displayword: '広告新規作成'},
      ]//広告編集(キャンペーン/新規)
    },
    {
      id: 23, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/campaigns', displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=cp',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 4,
          path: '/adgroupdetail/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=cp',
          displayword: '広告グループ詳細'
        },
        {
          id: 5,
          path: advertisementdetail_path + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}/${adid}` + '?type=cp',
          displayword: '広告詳細'
        },
        {id: 6, path: '?type=cp', displayword: '広告編集'},
      ]//広告編集(キャンペーン/更新)
    },
    {
      id: 24, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '/operation/zeus', displayword: 'Zeusキャンペーン一覧'},
        {
          id: 4,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=op',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 5,
          path: '/adgroupdetail/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=op',
          displayword: '広告グループ詳細'
        },
        {id: 6, path: '?type=op', displayword: '広告新規作成'},
      ]//広告編集(入稿/新規)
    },
    {
      id: 25, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '/operation/zeus', displayword: 'Zeusキャンペーン一覧'},
        {
          id: 4,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=op',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 5,
          path: '/adgroupdetail/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=op',
          displayword: '広告グループ詳細'
        },
        {
          id: 6,
          path: advertisementdetail_path + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}/${adid}` + '?type=op',
          displayword: '広告詳細'
        },
        {id: 7, path: '?type=op', displayword: '広告編集'},
      ]//広告編集(入稿/更新)
    },
    {
      id: 26, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/campaigns', displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=cp',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 4,
          path: '/adgroupdetail/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=cp',
          displayword: '広告グループ詳細'
        },
        {id: 5, path: '?type=cp', displayword: '広告詳細'},
      ]//広告詳細(キャンペーン)
    },
    {
      id: 27, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/operations', displayword: '配信設定TOP'},
        {id: 3, path: '/operation/zeus', displayword: 'Zeusキャンペーン一覧'},
        {
          id: 4,
          path: '/campaigndetailzeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}` + '?type=op',
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {
          id: 5,
          path: '/adgroupdetail/zeus/' + `${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}/${adgroupid}` + '?type=op',
          displayword: '広告グループ詳細'
        },
        {id: 6, path: '?type=op', displayword: '広告詳細'},
      ]//広告詳細(入稿)
    },
    {
      id: 28, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'ユーザー・ロール一覧'},
      ]//ユーザー一覧
    },
    {
      id: 29, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/users', displayword: 'ユーザー・ロール一覧'},
        {id: 3, path: '#', displayword: 'ユーザー新規作成'},
      ]//ユーザ一新規作成
    },
    {
      id: 30, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/users', displayword: 'ユーザー・ロール一覧'},
        {id: 3, path: '/userdetail/' + query, displayword: 'ユーザー詳細'},
        {id: 4, path: '#', displayword: 'ユーザー編集'},
      ]//ユーザ一編集
    },
    {
      id: 31, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/users', displayword: 'ユーザー・ロール一覧'},
        {id: 3, path: '#', displayword: 'ユーザー詳細'},
      ]//ユーザ一詳細
    },
    {
      id: 32, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/crassets', displayword: 'クリエイティブアセットTOP'},
        {id: 3, path: '/crassets/' + platform, displayword: 'クリエイティブアセット一覧（Zeus）'},
        {id: 4, path: '#', displayword: '広告アセット（動画）作成（Zeus）'}
      ]//クリエイティブ動画編集
    },
    {
      id: 33, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '/crassets', displayword: 'クリエイティブアセットTOP'},
        {id: 3, path: '/crassets/' + platform, displayword: 'クリエイティブアセット一覧'},
        {id: 4, path: '#', displayword: 'クリエイティブアセット詳細（動画）'}
      ]//クリエイティブ動画詳細
    },
    {
      id: 34, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: '通知メッセージ一覧'},
      ] // 通知メッセージ一覧
    },
    {
      id: 35, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: info_path, displayword: '通知メッセージ一覧'},
        {id: 3, path: '#', displayword: '通知メッセージ詳細'},
      ] // 通知メッセージ詳細
    },
    {
      id: 36, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: info_path, displayword: '通知メッセージ一覧'},
        {id: 3, path: '#', displayword: '通知メッセージ作成'},
      ] // 通知メッセージ作成
    },
    {
      id: 37, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: info_path, displayword: '通知メッセージ一覧'},
        {id: 3, path: infodetail_path + adid, displayword: '通知メッセージ詳細'},
        {id: 4, path: '#', displayword: '通知メッセージ編集'},
      ] // 通知メッセージ編集
    },
    {
      id: 38, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'アカウント別サマリー'}
      ] // アカウント別サマリー
    },
    {
      id: 39, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'}
      ] // キャンペーン一覧(Apollo)
    },
    {
      id: 40, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {id: 3, path: '#', displayword: 'キャンペーン（Apollo）詳細'},
      ] // キャンペーン詳細(Apollo)
    },
    {
      id: 41, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {id: 3, path: '#', displayword: 'キャンペーン（Apollo）新規作成'},
      ] // キャンペーン作成(Apollo)
    },
    {
      id: 42, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {
          id: 3,path: '#',displayword: 'キャンペーン（Apollo）詳細(廃止)'
        },
        {id: 4, path: '#', displayword: 'キャンペーン（Apollo）編集(廃止)'},
      ] // キャンペーン編集(Apollo)
    },
    {
      id: 43, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {id: 3, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）詳細'},
      ] // キャンペーン詳細(Zeus) ?queryType === "cp"
    },
    {
      id: 44, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: operations_path, displayword: '配信設定TOP'},
        {id: 3, path: operation_platform_path + platform, displayword: 'Zeusキャンペーン一覧'},
        {id: 4, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）詳細'},
      ] // キャンペーン詳細(Zeus) ?queryType === "op"
    }, {
      id: 45, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {id: 3, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）新規作成'},
      ] // キャンペーン作成(Zeus) ?queryType === "cp"
    },
    {
      id: 46, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: operations_path, displayword: '配信設定TOP'},
        {id: 3, path: operation_platform_path + platform, displayword: 'Zeusキャンペーン一覧'},
        {id: 4, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）新規作成'},
      ] // キャンペーン作成(Zeus) ?queryType === "op"
    },
    {
      id: 47, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: campaigns_path, displayword: 'キャンペーン一覧'},
        {
          id: 3,
          path: `${campaigndetailzeus_path}${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}?type=${query}`,
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {id: 4, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）編集'},
      ] // キャンペーン編集(Zeus) ?queryType === "cp"
    },
    {
      id: 48, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: operations_path, displayword: '配信設定TOP'},
        {id: 3, path: operation_platform_path + platform, displayword: 'Zeusキャンペーン一覧'},
        {
          id: 4,
          path: `${campaigndetailzeus_path}${state.current.accountGroupId}/${state.current.accountId}/${zeusaccountid}/${zeuscampaignid}?type=${query}`,
          displayword: 'キャンペーン（Zeus）詳細'
        },
        {id: 5, path: `?type=${query}`, displayword: 'キャンペーン（Zeus）編集'},
      ] // キャンペーン編集(Zeus) ?queryType === "op"
    },
    {
      id: 49, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'イベント一覧'},
      ] // イベント一覧(HERA)
    },
    {
      id: 50, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: 'オーディエンス一覧'},
      ] // オーディエンス一覧(HERA)
    },
    {
      id: 51, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: heraaudiences_path, displayword: 'オーディエンス一覧'},
        {id: 3, path: '#', displayword: 'オーディエンス詳細'},
      ] // オーディエンス詳細(HERA)
    },
    {
      id: 52, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: heraaudiences_path, displayword: 'オーディエンス一覧'},
        {id: 3, path: '#', displayword: 'オーディエンス新規登録'},
      ] // オーディエンス作成(HERA)
    },
    {
      id: 53, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: '測定ポイント一覧'},
      ] // 測定ポイント一覧(HERA)
    },
    {
      id: 54, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: herasetpoints_path, displayword: '測定ポイント一覧'},
        {id: 3, path: '#', displayword: '測定ポイント詳細'},
      ] // 測定ポイント詳細(HERA)
    },
    {
      id: 55, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: herasetpoints_path, displayword: '測定ポイント一覧'},
        {id: 3, path: '#', displayword: '測定ポイント新規登録'},
      ] // 測定ポイント作成(HERA)
    },
    {
      id: 56, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: '#', displayword: '確定請求金額'}
      ] // 確定請求金額
    },
    {
      id: 57, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {id: 4, path: '#', displayword: 'ユーザー・ロール一覧'},
      ] // ユーザー一覧 ?queryType === "ag"
    },
    {
      id: 58, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {
          id: 5,
          path: accountdetailzeus_path + state.current.accountGroupId + "/" + state.current.accountId + "/" + state.current.accountId + "/" + zeusaccountid,
          displayword: 'Zeusアカウント詳細'
        },
        {id: 6, path: '#', displayword: 'キャンペーン（Zeus）詳細'},
      ] // キャンペーン詳細(Zeus) ?queryType === "dtl"
    },
    {
      id: 59, data: [
        {id: 1, path: home_path, displayword: 'ホーム'},
        {id: 2, path: accountgroups_path, displayword: 'アカウントグループ一覧'},
        {id: 3, path: accountgroupdetail_path + state.current.accountGroupId, displayword: 'アカウントグループ詳細'},
        {
          id: 4,
          path: accountdetailapollo_path + state.current.accountGroupId + "/" + state.current.accountId,
          displayword: '広告主アカウント詳細'
        },
        {
          id: 5,
          path: accountdetailzeus_path + state.current.accountGroupId + "/" + state.current.accountId + "/" + zeusaccountid,
          displayword: 'Zeusアカウント詳細'
        },
        {id: 6, path: '#', displayword: 'キャンペーン（Zeus）新規作成'},
      ] // キャンペーン作成(Zeus) ?queryType === "ac"
    },
    // NOTE: 現状、bread_no は「id検索」ではなく配列インデックスとして参照されているため、
    //       削除や順序変更すると以降の画面でパンくず構造がずれる可能性がある。
    //       そのため、該当画面（id:60〜61）は削除せず空定義として残す。
    {
      id: 60,
      data: [], // セグメント一覧
    },
    {
      id: 61,
      data: [], // カスタムセグメント作成(ALL)
    },
    {
      id: 62,
      data: [], // カスタムセグメント編集(ALL)
    },
    {
      id: 63,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/customsegment/poseidon", displayword: "カスタムセグメント一覧" },
        { id: 3, path: "?type=prod", displayword: "カスタムセグメント詳細" },
      ], // カスタムセグメント詳細
    },
    {
      id: 64,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "アフィニティカテゴリ一覧" },
      ], // アフィニティカテゴリ一覧
    },
    {
      id: 65,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/affinitycategory/poseidon", displayword: "アフィニティカテゴリ一覧" },
        { id: 3, path: "#", displayword: "アフィニティカテゴリ作成" },
      ], // アフィニティカテゴリ作成
    },
    {
      id: 66,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/affinitycategory/poseidon", displayword: "アフィニティカテゴリ一覧" },
        { id: 3, path: "#", displayword: "アフィニティカテゴリ編集" },
      ], // アフィニティカテゴリ編集
    },
    {
      id: 67,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "カスタムセグメント一覧" },
      ], // カスタムセグメント一覧
    },
    {
      id: 68,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "ユーザーリスト一覧" },
      ], // ユーザーリスト一覧
    },
    {
      id: 69,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/userlist/poseidon", displayword: "ユーザーリスト一覧" },
        { id: 3, path: "#", displayword: "ユーザーリスト作成" },
      ], // ユーザーリスト作成
    },
    {
      id: 70,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/userlist/poseidon", displayword: "ユーザーリスト一覧" },
        { id: 3, path: "#", displayword: "ユーザーリスト編集" },
      ], // ユーザーリスト編集
    },
    {
      id: 71,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "予算管理" },
      ], // 予算管理
    },
    {
      id: 72,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "/budgets", displayword: "予算管理" },
        { id: 3, path: "#", displayword: "予算管理詳細" },
      ], // 予算管理詳細
    },
    {
      id: 73,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "マスター管理" },
      ], // マスター管理
    },
    // NOTE: 現状、「id検索」ではなく配列インデックスとして参照されているため、
    //       削除や順序変更すると以降の画面でパンくず構造がずれる可能性がある。
    //       そのため、該当画面（id:74）は削除せず空定義として残す。
    {
      id: 74,
      data: [], // レポート管理
    },
    {
      id: 75,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "操作履歴一覧" },
      ], // 操作履歴一覧
    },
    {
      id: 76,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "レポート管理" },
      ], // レポート管理V2
    },
    {
      id: 77,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: reports_path, displayword: "レポート管理" },
        { id: 3, path: "#", displayword: "レポート新規作成" },
      ], // レポート管理V2
    },
    {
      id: 78,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: reports_path, displayword: "レポート管理" },
        { id: 3, path: "#", displayword: "予約レポート詳細" },
      ], // レポート管理V2
    },
    {
      id: 79,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "トラッカーID移行" },
      ], // トラッカーID移行
    },
    {
      id: 80,
      data: [
        { id: 1, path: home_path, displayword: "ホーム" },
        { id: 2, path: "#", displayword: "過去分レポート管理" },
      ], // 過去分レポート管理
    },
  ];

  // @ts-ignore
  const x: BreadcrumbsData = global_breadcrumbNameMap[bread_no].data;
  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb">
      {x.map((bread: any) => (
        <Link color="inherit" to={bread.path} key={bread.id}
              className={classes.breadlink}>
          {
            bread.displayword
          }
        </Link>
      ))}
    </Breadcrumbs>
  );
};
